export enum ClauseTag {
  CONTRACT,
  OLD_CONTRACT,
  JOB_FAIRS,
  CV,
  F_MOBILE_APP,
  PRACA_REGISTRATION,
  INFOPRACA_REGISTRATION,
  PRACUJ_REGISTRATION,
  F_WWW_REGISTRATION,
  F_PP_REGISTRATION,
  F_REGISTRATION,
  C_WWW_REGISTRATION,
  C_WWW_MAIL_REGISTRATION_NO_OFFER,
  C_WWW_MAIL_REGISTRATION_WITH_OFFER,
  MAIL_REGISTRATION
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/clause/clause-tag.enum.ts